export const isValidEventDate = (date) => {
  const time = date?.time.split(':', 2);
  const eventDate = new Date(
    date?.year_number,
    date?.month_number - 1,
    date?.day_number,
    time && time[0],
    time && time[1]
  );
  const targetDate = eventDate.getTime();
  const currentDate = new Date().getTime();
  return targetDate > currentDate;
};

export const hasValidEvents = (league) => {
  const filtered = league.events.filter((event) => isValidEventDate(event.date));
  return filtered?.length > 0;
};

export const getFeaturedEvent = (relation) => {
  const schedule = relation?.schedule;
  const scheduleArray = schedule && Object.keys(schedule).map((key) => schedule[key]);
  const tournaments = scheduleArray && scheduleArray[0]?.tournaments;
  const tournamentsArray = tournaments && Object.keys(tournaments).map((key) => tournaments[key]);

  const date = new Date();
  const today = date.getDate();
  // it shows the top featured event for today that has not finished yet
  // if there are no unfinished featured events for today: show top event for today that has not finished yet
  // if there are no unfinished events for today: don't render the component at all
  const featuredEvent =
    (relation?.featured_events && relation?.featured_events[0]) ||
    (tournamentsArray &&
      tournamentsArray[0].events[0].date.day_number == today &&
      tournamentsArray[0].events[0]);

  return featuredEvent;
};
